<ng-container *ngIf="planChangeSummary$ | async as summary; else loading">
  <div class="row">
    <div class="col-xl-8">
      <div class="card mt-4 ms-4">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Upgrade Plan</h2>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <h4 class="col-lg-12 text-lg-center py-4">Current Plan</h4>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Plan:</p>
                <p class="col-lg-6 fw-bold">{{ summary.currentPlan.name }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.currentPlan.pricePerLicence
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Billing Frequency:</p>
                <p class="col-lg-6 fw-bold">{{ summary.currentPlan.type | capitalize }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Total Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.currentPlan.currentLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Recurring Charges:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.currentPlan.recurringAmount
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Plan Start Date:</p>
                <p class="col-lg-6 fw-bold">
                  {{ summary.currentPlan.planStartDate | date: 'MMM dd, yyyy' }}
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <h4 class="col-lg-12 text-lg-center py-4">New Plan</h4>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Plan:</p>
                <p class="col-lg-6 fw-bold">{{ summary.newPlan.name }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.newPlan.pricePerLicence
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Billing Frequency:</p>
                <p class="col-lg-6 fw-bold">{{ summary.newPlan.type | capitalize }}</p>
              </div>
              <!--<div class="row">
                <p class="col-lg-6 text-lg-end">Total Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.newPlan.requestedLicences }}</p>
              </div>-->
              <div class="row align-items-center">
                <!-- <p class="col-lg-6 text-lg-end">Total Licences:</p> -->
                <p
                  class="col-lg-6 d-flex justify-content-lg-end justify-content-center align-items-center mb-0"
                >
                  Total Licences:
                </p>
                <div class="col-lg-6">
                  <div class="input-group input-group-sm" style="max-width: 120px">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.newPlan.requestedLicences - 1,
                          summary.newPlan.minimumLicences
                        )
                      "
                      [disabled]="
                        summary.newPlan.requestedLicences <= summary.newPlan.minimumLicences
                      "
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="form-control text-center"
                      [value]="summary.newPlan.requestedLicences"
                      [min]="summary.newPlan.minimumLicences"
                      (input)="
                        onLicenceChange(
                          $any($event.target).valueAsNumber,
                          summary.newPlan.minimumLicences
                        )
                      "
                      aria-label="Number of licences"
                    />
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.newPlan.requestedLicences + 1,
                          summary.newPlan.minimumLicences
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <!--<div class="row">
                <p class="col-lg-6 text-lg-end">Minimum Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.newPlan.minimumLicences }}</p>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 theiaStickySidebar">
      <div class="card mt-4 me-4">
        <div class="card-body">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Change Calculation</h2>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Total days in current plan</span>
            <span class="value">
              {{ summary.billingSummary.oldPlanCalculation.cycleTotalDays }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Remaining days in current plan</span>
            <span class="value">
              {{ summary.billingSummary.oldPlanCalculation.cycleRemainingDays }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Price per day of current plan</span>
            <span class="value">
              {{
                summary.billingSummary.oldPlanCalculation.pricePerDay
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Prorated amount of current plan</span>
            <span class="value">
              {{
                summary.billingSummary.oldPlanCalculation.proratedAmount
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Prorated used amount of current plan</span>
            <span class="value">
              {{
                summary.billingSummary.usedAmount
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Total days in new plan</span>
            <span class="value">
              {{ summary.billingSummary.newPlanCalculation.cycleTotalDays }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Remaining days in new plan</span>
            <span class="value">
              {{ summary.billingSummary.newPlanCalculation.cycleRemainingDays }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Price per day of new plan</span>
            <span class="value">
              {{
                summary.billingSummary.newPlanCalculation.pricePerDay
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div class="summary-row pt-4">
            <span class="label">Prorated amount of new plan</span>
            <span class="value">
              {{
                summary.billingSummary.newPlanCalculation.proratedAmount
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div class="d-flex justify-content-between border-bottom pb-2 pt-4">
            <h2>Billing Summary</h2>
          </div>

          <div *ngIf="summary.billingSummary.proratedCostForNewPlan > 0" class="summary-row pt-4">
            <span class="label">Cost of new plan (prorated)</span>
            <span class="value">
              <!-- - -->
              {{
                summary.billingSummary.proratedCostForNewPlan
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <div *ngIf="summary.billingSummary.unusedCredit > 0" class="summary-row credit pt-4">
            <span class="label">Credit for unused time on current plan</span>
            <span class="value">
              <!-- - -->
              <!-- {{
                summary.billingSummary.proratedCreditFromOldPlan
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }} -->
              {{
                summary.billingSummary.unusedCredit
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>

          <div class="summary-row pt-4">
            <span> Subtotal Amount </span>

            <strong>
              {{ summary.billingSummary.taxableAmount | currency: summary.billingSummary.currency }}
            </strong>
          </div>

          <div class="summary-row">
            <span> Integrated GST ({{ summary.billingSummary.gstRate }}%) </span>

            <strong>
              {{ summary.billingSummary.gstAmount | currency: summary.billingSummary.currency }}
            </strong>
          </div>

          <div
            *ngIf="summary.billingSummary.existingCreditBalanceApplied > 0"
            class="summary-row credit"
          >
            <span class="label">Applied from account balance</span>
            <span class="value">
              -
              {{
                summary.billingSummary.existingCreditBalanceApplied
                  | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
              }}
            </span>
          </div>
          <hr />
          <div class="total-row">
            <div *ngIf="summary.billingSummary.amountDueToday > 0" class="amount-due">
              <span class="label">Amount Due Today</span>
              <span class="value">
                {{
                  summary.billingSummary.amountDueToday
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
            <div
              *ngIf="summary.billingSummary.creditGeneratedOnDowngrade > 0"
              class="credit-generated"
            >
              A credit of
              <strong>
                {{
                  summary.billingSummary.creditGeneratedOnDowngrade
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </strong>
              will be added to your account balance.
            </div>

            <div
              *ngIf="
                summary.billingSummary.amountDueToday <= 0 &&
                summary.billingSummary.creditGeneratedOnDowngrade <= 0
              "
            >
              <span class="label">Amount Due Today</span>
              <span class="value">
                {{ 0 | currency: summary.billingSummary.currency : 'symbol' : '1.2-2' }}
              </span>
            </div>
          </div>
          <div class="d-grid mt-4">
            <button (click)="changePlan()" class="btn btn-primary" type="button">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center p-5">
    <!--<p>Loading plan summary...</p>-->
  </div>
</ng-template>
